<template>
	<div class="pricelist">
		<!-- NARXLASH BO'LIMIDAGI DOCUMENTLAR KO'RINADIGAN COMPONENT -->
		<b-card header-tag="header" footer-tag="footer">
			<div slot="header" class="top-card">
				<div class="d-flex justify-content-center align-items-center">
					<h5 class="mb-0" style="white-space: nowrap">{{$t('pricing.title')}}</h5>
				</div>
				<div class="d-flex justify-content-center align-items-center">
					<div class="notWrappedPricing mr-1">
						<b-button variant="outline-primary" size="sm" @click.prevent="openSidebar">
							<i class="fa fa-plus"></i>
						</b-button>
					</div>
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link class="card-header-action btn-setting" style="font-size: 15px">
							<i class="fa fa-th"></i>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<b-row class="p-3">
								<b-col cols="12" v-for="fieldItem in fields" :key="fieldItem.key + 'field'" @click="setFields(fieldItem)">
									<b-checkbox v-if="fieldItem.changebale"  v-model="fieldItem.visible" disabled> {{fieldItem.label}} </b-checkbox>
								</b-col>
							</b-row>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</div>
			<b-modal v-model="openViewPrice" size="xl" hide-footer :title="$t('goods.title')">
				<view-priceing :viewPricingArray = "viewPricingArray"></view-priceing>
			</b-modal>
			<b-table class="generalTableClass"
					 :hover="hover"
					 :striped="striped"
					 :bordered="bordered"
					 :small="small"
					 :fixed="fixed"
					 :items="getTableItems"
					 responsive="sm"
					 :fields="computedFields"
					 show-empty
			>
				<!-- EMPTY SLOT FOR TABLE -->
				<template slot="empty" slot-scope="scope">
					<h4>{{ $t('empty') }}</h4>
				</template>

				<template slot="id" slot-scope="data">
					<strong>{{ data.item.id }}</strong>
				</template>
				<template slot="costDate" slot-scope="data">
					<strong>{{ data.item.costDate }}</strong>
				</template>
				<template slot="costNumber" slot-scope="data">
					<strong>{{ data.item.costNumber }}</strong>
				</template>
				<template slot="companies" slot-scope="data">
					<div v-for="(company,index) in data.item.companies">
						<b-row>
							<b-col>
								<strong>{{index + 1}}. </strong>
								<strong>{{ company.name }}</strong>
							</b-col>
							<b-col cols="3" align="center">
								<b-link v-if="data.item.pricingStatus==='READY'" :to="`/point-of-sale/prices-generate/${data.item.id}/${company.id}`" class="text-success">
									<i class="fa fa-money"></i>
								</b-link>
								<b-link v-if="data.item.pricingStatus==='READY'" class="text-dark ml-2" variant="outline" @click.prevent="viewAkt(data.item.id,company.id)">
									<i class="fa fa-eye"></i>
								</b-link>
							</b-col>
						</b-row>
					</div>
				</template>
				<template slot="comment" slot-scope="data">
					<strong>{{data.item.comment}}</strong>
				</template>
				<template slot="actions" slot-scope="data">
					<b-link v-if="selected !== 'pricingDocs'" variant="outline" @click.prevent="viewPrice(data.item.id,data.item.docId)">
						<i class="fa fa-eye"></i>
					</b-link>
					<b-link v-if="selected=='pricingDocs'&&data.item.pricingStatus==='READY'" variant="outline" @click.prevent="viewAkt(data.item.id)">
						<i class="fa fa-eye"></i>
					</b-link>
					<b-link v-if="data.item.pricingStatus==='READY'" @click.prevent="viewPrices(data.item.id)" class="ml-2 text-primary">
						<i class="fa fa-money"></i>
					</b-link>
					<b-link v-if="data.item.pricingStatus=='SUSPENDED'" variant="outline"
							@click.prevent="editPrice(data.item.id, data.item.byExcel)">
						<i class="fa fa-pencil"></i>
					</b-link>
				</template>
				<!-- PRICING ITEMS FIELDS -->
				<template slot="number" slot-scope="data">
					<strong>{{ data.index + 1 }}</strong>
				</template>

				<template slot="details" slot-scope="data">
					{{ data.item.name }} / <strong>{{ data.item.colorName }} /
					{{ data.item.size }}</strong>
				</template>

				<template slot="barcode" slot-scope="data">
					{{ data.item.barcode }}
				</template>

				<template slot="artikul" slot-scope="data">
					{{ data.item.artikul }}
				</template>

				<template slot="incomeUzs" slot-scope="data">
						<span v-if="data.item.incomeUzs > 0">
									{{data.item.incomeUzs | currency({
								symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
					<span v-else> </span>
				</template>
				<template slot="extraCosts" slot-scope="data">
					<span>{{data.item.extraCosts | currency({
								symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}</span>
				</template>
				<template slot="paid" slot-scope="data">
					<span v-if="data.item.paid==true"><span style="color: green">Pretul este dat</span></span>
					<span v-else><span style="color: orange">Prețul nu este dat</span></span>
				</template>
				<template slot="uzb" slot-scope="data">
								<span v-if="data.item.priceUzs > 0">
									{{data.item.priceUzs | currency({
								symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
					<span v-else> </span>
				</template>
				<template slot="lastPriceWholesale" slot-scope="data">
								<span v-if="data.item.priceWholesale > 0">
									{{data.item.priceWholesale | currency({
								symbol: userDepCurrencyName, fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
								})}}
								</span>
					<span v-else> </span>
				</template>

			</b-table>
			<div v-if="loading" class="spinner-wrapper">
				<b-spinner variant="primary"></b-spinner>
			</div>
			<nav>
				<b-pagination
					size="sm"
					:total-rows="total"
					:per-page="perPage"
					v-model="currentPage"
					:prev-text="$t('pagination.prev')"
					:next-text="$t('pagination.next')"
					hide-goto-end-buttons
				/>
			</nav>
		</b-card>

		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar"
			spacer
			v-model="activeSidebar"
			:click-not-close="true"
		>
			<PriceAdd :editItem="editItem" :editable="editable" :isFromExcel="isFromExcel" @closeSidebar="closeSidebar"
					  :isSidebarOpen="activeSidebar"></PriceAdd>
		</vs-sidebar>

		<!-- QOP UCHUN NARXLASH -->
		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar"
			spacer
			v-model="activeSidebarForWrapped"
			:click-not-close="true"
		>
			<CreatePricingForWrapped :editItem="editItem" :editable="editable" @closeSidebar="closeSidebarForWrapped"
					  :isSidebarOpen="activeSidebarForWrapped"></CreatePricingForWrapped>
		</vs-sidebar>

		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar"
			spacer
			v-model="activeEditSidebar"
			:click-not-close="true"
		>
			<PriceEdit @closeSidebar="closeSidebar"></PriceEdit>
		</vs-sidebar>

	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import PriceAdd from './Prices'
import CreatePricingForWrapped from './CreatePricingForWrapped'
import PriceEdit from './PriceEdit'
import PricesService from "../../services/prices.service";
import ViewPriceing from "./viewPriceing";
import VisibleColumns from "../warehouse-management/goods/blocks/VisibleColumns";

	export default {
		components: {
			ViewPriceing,
			PriceAdd,
			CreatePricingForWrapped,
			PriceEdit,
			VisibleColumns
		},
		props: {
			caption: {
				type: String,
				default: 'Users'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
                isFromExcel: false,
                loading: false,
				editable: false,
				activeSidebar: false,
				activeSidebarForWrapped: false,
				currentPage: 1,
				perPage: 20,
				regnumber: '',
				items: [],
				fields: [
					{
						key: 'id',
						label: 'ID',
						'class': 'role_id',
						sortable: true,
						changebale: false,
						visible: true
					},
					{
						key: 'costDate',
						label: this.$t('pricing.costDate'),
						changebale: true,
						visible: true
					},
					{
						key: 'costNumber',
						label: this.$t('pricing.costNumber'),
						changebale: true,
						visible: true
					},
					{
						key: 'docCreatedDate',
						label: 'Дата создания',
						changebale: true,
						visible: false
					},
					{
						key: 'docCreatedBy',
						label: 'Создатель',
						changebale: true,
						visible: false
					},
					{
						key: 'docChangeDate',
						label: 'Дата обновления',
						changebale: true,
						visible: false
					},
					{
						key: 'docLastModifiedBy',
						label: 'Обнавлён',
						changebale: true,
						visible: false
					},
					{
						key: 'companies',
						label: this.$t('pricing.department'),
						changebale: true,
						visible: true
					},
					{
						key: 'comment',
						label: this.$t('promo-to-product.comment'),
						changebale: true,
						visible: true
					},
					{
						key: 'pricingStatus',
						label: this.$t('sale.status'),
						changebale: true,
						visible: true
					},
					{
						key: 'actions',
						'class': 'table_actions',
						label: this.$t('prices.item.actions'),
						changebale: false,
						visible: true
					}
				],
				computedFields: [],
				isValid: '',
				openViewPrice:false,
				viewPricingArray:[],
				editItem: {},
				activeEditSidebar: false,
				currentDate: new Date().toISOString().slice(0, 10),
				options: [],
				selected: 'pricingDocs',
				filter: {
					departmentIds: [this.userDepId],
					docIdAndDocName: '',
					page: 1,
					limit: 20
				},
				attr: {}
			}
		},
		watch: {
			currentPage: {
				async handler() {
					if (this.selected == 'pricingDocs') {
						let paramsForSearch = {
							page: this.currentPage,
							limit: this.perPage
						};
						this.getPricingAllList(paramsForSearch);
					}
				}
			},
			selected: {
				handler(newValue) {
					if (newValue == 'pricingDocs') {
						let paramsForSearch = {
							page: this.currentPage,
							limit: this.perPage
						};
						this.getPricingAllList(paramsForSearch);
					}
				}
			}
		},
		async mounted() {
			// Pricing List actions
			if (this.selected == 'pricingDocs') {
				let paramsForSearch = {
					page: this.currentPage,
					limit: this.perPage
				};
				await this.getPricingAllList(paramsForSearch);
			}
		},
		methods: {
			setFields(item) {
				if (item) {
					item.visible = !item.visible
				}
				let tmp = []
				this.fields.forEach(t => {
					if (t.visible) {
						tmp.push(t)
					}
				})
				this.computedFields = tmp
			},
			setFilterToComponent() {
				this.attr['link'] = "departmentIds=" + this.userDepId +
					"&docIdAndDocName=" + `${this.filter.docIdAndDocName !== '' ? this.filter.docIdAndDocName : null}` +
					"&page=" + this.currentPage +
					"&limit=" + this.filter.limit
			},
			setFilterToComponent3() {
				this.attr['link'] = "departmentIds=" + this.userDepId +
					"&page=" + this.currentPage +
					"&limit=" + this.filter.limit
			},
			setFilterToComponent4() {
				this.attr['link'] = "depIds=" + this.userDepId +
					"&page=" + this.currentPage +
					"&limit=" + this.filter.limit
			},
			async getListBySection3() {
				this.setFilterToComponent3();
				await this.getPricingItemsWithPaginationSection3(this.attr.link);
			},
			async getListBySection4() {
				this.setFilterToComponent4();
				await this.getPricingItemsWithPaginationSection4(this.attr.link);
                this.loading = false;
            },
			async searchPricing() {
				await this.setFilterToComponent()
				await this.getPricingItemsWithPagination(this.attr.link);
			},
			getDateCurrent() {
				this.currentDate = (new Date().toISOString().slice(0, 10));
			},
			getDepartmentsLocal() {
				return this.getDepartments
			},
			async viewPrice(docId) {
				if (this.selected == 'extraCost') {
					PricesService.viewPricingList(docId).then(response => {
						this.viewPricingArray = response.data.whItems;
						this.openViewPrice = true;
					})
				} else {
					this.activeEditSidebar = true
					await this.getEditPricing(docId)
					this.editItem = this.getEditItems
				}
			},
			viewAkt(id, depId) {
				if (depId) {
					this.$router.push(`/point-of-sale/prices/doc/${id}/${depId}`)
				} else {
					this.$router.push(`/point-of-sale/prices/doc/${id}/allDeps`)
				}
			},
			viewPrices(id) {
				this.$router.push(`/point-of-sale/prices-generate/${id}/null`)
			},
			async editPrice(pricingId, isFromExcel = false) {
				this.editable = true;
				this.isFromExcel = isFromExcel
				this.activeEditSidebar = true
				this.activeSidebar = true;
				await this.getEditPricing(pricingId)
				this.getDepartmentsLocal();
				this.getDepartmentList();
				this.editItem = this.getEditItems


			},
			...mapActions('prices', [
				'getPricingAllList', 'getEditPricing', 'getPricesList', 'getPricingItemsWithPaginationSection4',
				'getRegNumberItem', 'getDepartmentList', 'getPricingItemsWithPagination', 'getPricingItemsWithPaginationSection3'
			]),
			...mapMutations('prices', [
				'setRegNumber', 'setDocId'
			]),
			openSidebar() {
				let data = {
					costNumber: null,
					costDate: null,
					employeeId: null,
					companies: null,
					companiesIds: null,
					pricingItems: null,
					comment: null,
					pricingStatus: "DRAFT",
					byExcel: null
				}
				PricesService.getRegNumber(data).then(res => {
					this.setRegNumber(res.data.costNumber)
					this.setDocId(res.data.id)
					this.activeSidebar = true
					this.getDateCurrent();
					// this.getPricesList();
					// this.getRegNumberItem();
					this.getDepartmentsLocal();
					this.getDepartmentList();
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			},
			async closeSidebar() {
				this.activeSidebar = false;
				this.editable = false;
				this.activeEditSidebar = false;
				if (this.selected != 'pricingDocs') {
					this.selected = 'pricingDocs';
					return;
				}
				let paramsForSearch = {
					page: this.currentPage,
					limit: this.perPage
				};
				await this.getPricingAllList(paramsForSearch);
			},
			async openSidebarForWrapped() {
				this.activeSidebarForWrapped = true
				this.getDateCurrent();
				// this.getPricesList();
				await this.getRegNumberItem();
				this.getDepartmentsLocal();
				this.getDepartmentList();

			},
			async closeSidebarForWrapped() {
				this.activeSidebarForWrapped = false;
				this.editable = false;
				this.activeEditSidebar = false;
				if (this.selected != 'pricingDocs') {
					this.selected = 'pricingDocs';
					return;
				}
				let paramsForSearch = {
					page: this.currentPage,
					limit: this.perPage
				};
				await this.getPricingAllList(paramsForSearch);
			},

		},
		computed: {
			getTableItems() {
				if (this.isPricingDocs == "pricingDocs") {
					return this.getPricing;
				}
			},
			isPricingDocs() {
				return this.selected;
			},
			...mapState(['userDepId', 'userDepCurrencyName']),
			...mapState('prices', [
				'total', 'pricingItemsTotal', 'pricingItems', 'pricingItemsSection3', 'totalSection3', 'pricingItemsSection4', 'totalSection4'
			]),
			...mapGetters('prices', [
				'getPricing', 'getEditItems', 'getDepartments', 'getRegNumber'
			])
		},
		created() {
			this.setFields();
		}
	}
</script>
<style scoped lang="scss">
	.top-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
